
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-code-of-conduct",
      function () {
        return require("private-next-pages/ai-code-of-conduct/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-code-of-conduct"])
      });
    }
  